import apiClient from "@/shared/http/api-client";

const BASE = "/checklist";
const LEARNER = "/checklist/learner";

export default {
  // ── Admin endpoints ──
  list(params) {
    return apiClient.get(BASE, { params });
  },
  get(id) {
    return apiClient.get(`${BASE}/${id}`);
  },
  create(data) {
    return apiClient.post(BASE, data);
  },
  update(id, data) {
    return apiClient.put(`${BASE}/${id}`, data);
  },
  publish(id) {
    return apiClient.post(`${BASE}/${id}/publish`);
  },
  clone(id) {
    return apiClient.post(`${BASE}/${id}/clone`);
  },
  remove(id) {
    return apiClient.delete(`${BASE}/${id}`);
  },
  upload(jsonData) {
    return apiClient.post(`${BASE}/upload`, jsonData);
  },

  // ── Learner endpoints ──
  getActive() {
    return apiClient.get(`${LEARNER}/active`);
  },
  getResponse() {
    return apiClient.get(`${LEARNER}/response`);
  },
  saveResponse(data) {
    return apiClient.put(`${LEARNER}/response`, data);
  },
  switchVersion() {
    return apiClient.post(`${LEARNER}/switch-version`);
  },
};
